import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/api";

export function EnvDeviceRoute({ envKey, children }) {
  const { code } = useParams();
  const [ready, setReady] = useState(false);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let ok = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/environments/resolve/${code}`);
        localStorage.setItem(envKey, data.id);
        if (ok) setReady(true);
      } catch (e) { if (ok) setErr(true); }
    })();
    return () => { ok = false; };
  }, [code, envKey]);
  if (err) return <div style={{ padding: 40, color: "#fca5a5", background: "#0f172a", minHeight: "100vh", fontFamily: "sans-serif" }} data-testid="env-unknown">Onbekende omgeving: {code}</div>;
  if (!ready) return <div style={{ padding: 40, color: "#94a3b8", background: "#0f172a", minHeight: "100vh", fontFamily: "sans-serif" }}>Omgeving laden…</div>;
  return children;
}
